var _a;
import { AwsUi } from '../../../../core/runtime/src';
import { Icon } from '../../../icon/src';
import { S3_RESOURCE_SELECTOR_ITEM_TYPES } from './s3-config';
var bucketNameCellTemplate = function (onItemClick, isDrilldownAllowedForItem) { return function (item) { return (AwsUi.__createElement("div", null, isDrilldownAllowedForItem(item) ? (AwsUi.__createElement("a", { onclick: function () { return onItemClick(item); }, href: "javascript:void(0)" }, item.Name)) : (item.Name))); }; };
export var getIconType = function (item) { return (item.IsFolder ? 'folder' : 'file'); };
var objectKeyCellTemplate = function (onItemClick, isDrilldownAllowedForItem) { return function (item) { return (AwsUi.__createElement("div", null,
    AwsUi.__createElement(Icon, { name: getIconType(item) }),
    ' ',
    isDrilldownAllowedForItem(item) ? (AwsUi.__createElement("a", { className: "awsui-util-ml-xs", onclick: function () { return onItemClick(item); }, href: "javascript:void(0)" }, item.Key)) : (item.Key))); }; };
export var cellTemplates = (_a = {},
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.BUCKETS] = bucketNameCellTemplate,
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.OBJECTS] = objectKeyCellTemplate,
    _a[S3_RESOURCE_SELECTOR_ITEM_TYPES.VERSIONS] = null,
    _a);
//# sourceMappingURL=cell-templates.js.map